export interface AppointmentsDTO {
    startDate: Date
    endDate: Date,
    title: string
    notification: number
    labels: string[]
    notes: string
    userId: string
    id: string
    status: AppointmentsStatus
    financialAdvisorId: string
    companyId: string
    type: AppointmentsType
    typology: AppointmentsTypology
}

export enum AppointmentsStatus {
    idle = "idle",
    pending = "pending",
    refused = "refused",
    confirmed = "confirmed"
}

export enum AppointmentsType {
    appointents = "appointments"
}

export enum AppointmentsTypology {
    consulting = "consulting",
    payments = "payments",
    deadlines = "deadlines",
    grants = "grants",
    payroll = "payroll",
    planning = "planning",
    other = "other"
}

export interface AppointmentsCreateDTO {
    startDate: string
    endDate: string
    title: string
    notes: string
    financialAdvisorId: string
    status: AppointmentsStatus
    companyId: string
    typology: AppointmentsTypology
}

export interface AppointmentsUpdateRequestDTO {
    startDate: string
    endDate: string
}

export interface AppointmentFiltersDTO {
    page: number;
    sort?: string;
    fromDate?: string;
    toDate?: string;
    financialAdvisorId?: string
    companyId?: string,
    itemsPerPage?:  number
    order: boolean
}

export interface AppointmentResponseDTO {
    data: AppointmentsDTO[],
    paginationData: { total: number, page: number, perPage: number, prev: number, next: number, totalPage: number }
}

export interface UpdateStatusRequest {
    status: AppointmentsStatus
}

export const statusAppointmentMap = new Map<AppointmentsStatus, string>([
    [AppointmentsStatus.idle, 'In attesa'],
    [AppointmentsStatus.confirmed, 'Confermato'],
    [AppointmentsStatus.refused, 'Rifiutato'],
    [AppointmentsStatus.pending, 'In attesa'],
])
